import Awning from "./awning.svg";
import Bay from "./bay.svg";
import Casement from "./casement.svg";
import DoubleHung from "./double-hung.svg";
import OtherWindow from "./other-window.svg";
import SingleHung from "./single-hung.svg";
import Sliding from "./sliding.svg";

const icons = {
  awning: Awning,
  bay: Bay,
  casement: Casement,
  "single-hung": SingleHung,
  "double-hung": DoubleHung,
  sliding: Sliding,
  "other-window": OtherWindow,
};

export default icons;
